module.exports = __webpack_public_path__ + "img/news-silva-numerica.ab93a331.png";